import React from "react";
import { ArrowRightIcon, CheckIcon } from "../Icons";
import { PrimaryLink, Section, SectionHeading, SectionLabel } from "../ui";
import { SERVICE_TIERS } from "../content";

export default function ServiceTiers({ pricingUrl }: { pricingUrl: string }) {
  return (
    <Section id="options" className="tw-scroll-mt-24">
      <div className="tw-mx-auto tw-max-w-3xl tw-text-center">
        <SectionLabel>Platform, supported or managed</SectionLabel>
        <SectionHeading>The right level of support for your team.</SectionHeading>
        <p className="tw-mt-5 tw-mb-0 tw-text-lg tw-leading-8 tw-text-[#5b7188]">
          Use the platform on your own, add launch support, or let us manage the whole programme.
        </p>
      </div>

      <div className="tw-mt-12 tw-grid tw-grid-cols-3 tw-gap-5 sm:tw-grid-cols-1">
        {SERVICE_TIERS.map((tier) => (
          <article
            key={tier.eyebrow}
            className={`tw-relative tw-rounded-[26px] tw-border tw-p-7 ${
              tier.badge
                ? "tw-border-[#087bd3] tw-bg-[#eef7fd] tw-shadow-[0_18px_50px_rgba(27,93,139,.12)]"
                : "tw-border-[#d4e2ee] tw-bg-white"
            }`}
          >
            {tier.badge ? (
              <span className="tw-absolute tw-right-5 tw-top-5 tw-rounded-full tw-bg-[#0068b8] tw-px-3 tw-py-1 tw-text-[11px] tw-font-black tw-uppercase tw-tracking-wider tw-text-white">
                {tier.badge}
              </span>
            ) : null}

            <p
              className={`tw-m-0 tw-text-xs tw-font-black tw-uppercase tw-tracking-[.12em] tw-text-[#0068b8] ${
                tier.badge ? "tw-pr-24" : ""
              }`}
            >
              {tier.eyebrow}
            </p>
            <h3 className="tw-mt-5 tw-mb-0 tw-text-2xl tw-font-black tw-leading-8 tw-tracking-[-.03em] tw-text-[#163552]">
              {tier.title}
            </h3>
            <p className="tw-mt-4 tw-mb-0 tw-min-h-24 tw-leading-7 tw-text-[#5b7188] sm:tw-min-h-0">
              {tier.body}
            </p>

            <ul className="tw-mt-6 tw-mb-0 tw-list-none tw-space-y-3 tw-border-t tw-border-[#cedeeb] tw-p-0 tw-pt-6">
              {tier.includes.map((item) => (
                <li key={item} className="tw-flex tw-gap-3 tw-text-sm tw-font-bold tw-text-[#314b64]">
                  <CheckIcon aria-hidden className="tw-mt-0.5 tw-h-4 tw-w-4 tw-shrink-0 tw-text-[#0068b8]" />
                  {item}
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>

      <div className="tw-mt-10 tw-flex tw-justify-center">
        <PrimaryLink href={pricingUrl}>
          See pricing and build an estimate
          <ArrowRightIcon aria-hidden className="tw-h-4 tw-w-4 tw-shrink-0" />
        </PrimaryLink>
      </div>
    </Section>
  );
}
